import { router, useLocalSearchParams, useNavigation } from 'expo-router';
import { useEffect, useLayoutEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import GoBackButton from '@/components/buttons/GoBackButton';
import FormWrapper from '@/components/forms/FormWrapper';
import SalaryForm from '@/components/forms/SalaryForm';
import Title from '@/components/Title';
import { SalaryData } from '@/lib/validations/NpoOnboardingSchema';
import { i18n } from '@/utils/i18n';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdateSalary = () => {
  const navigation = useNavigation<any>();
  const { salaryDataJson, salaryIndex } = useLocalSearchParams<{
    salaryDataJson: string;
    salaryIndex: string;
  }>();
  const [initialSalaryData, setInitialSalaryData] = useState<SalaryData | undefined>(undefined);

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerTransparent: true,
      headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.salaries.add_title')} />,
      headerLeft: () => <GoBackButton navigateTo={'/login/nonProfit/onBoarding/salaries'} />,
      headerBackVisible: false
    });
  }, [navigation]);

  useEffect(() => {
    if (salaryDataJson) {
      const parsedSalary = safeJsonParse<SalaryData>(salaryDataJson);
      if (parsedSalary) setInitialSalaryData(parsedSalary);
    }
  }, [salaryDataJson]);

  return (
    <SafeAreaView style={styles.content}>
      <FormWrapper keyboardVerticalOffset={0} scrollEnable={false}>
        <View style={styles.container}>
          <SalaryForm
            initialData={initialSalaryData}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/(app)/login/nonProfit/onBoarding/salaries',
                params: {
                  salaryDataJson: JSON.stringify(data),
                  salaryIndex: salaryIndex
                }
              });
            }}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1,
    marginTop: 60
  }
});

export default AddUpdateSalary;
